module.exports = __webpack_public_path__ + "img/assembly.609933b2.png";